import PackageConfig from "./PackageConfig"

class Constant {
    Environment = PackageConfig.Environment === undefined ? 2 : PackageConfig.Environment   // 0测试环境1；1 测试环境2；2 生产环境；3 测试环境3；4 灰度1；5 灰度2；
    WebsiteSign = PackageConfig.WebsiteSign === undefined ? "TEST_NULL(bucunzaidedizhi)" : PackageConfig.WebsiteSign//未配置的先拉Test目录
    RemindMissingRes = true             // 是否提醒缺失资源
    CheckSignalAPI = "/api/home/checkNetWorkStatus" //检测信号使用的API
    BangLength = 62                     // ipx刘海长度
    HotUpdateStorageFolder = "bigplay-remote-asset"    // 热更文件夹
    HotUpdateStoragePath = (cc.sys.isNative ? jsb.fileUtils.getWritablePath() : '/') + this.HotUpdateStorageFolder  // 热更资源的存储路径
    PopSwitch = true//!CC_DEBUG               // 只有非调试模式才打开弹窗开关
    DefaultMusicVolume = 0.5            // 默认的音乐音量（0-1）
    DefaultSoundVolume = 1              // 默认的音效音量（0-1）
    TestEncrypt = PackageConfig.TestEncrypt // 测试版的加密算法
    LanguagesCode = [
        "zh_CN",        // 中国
        "en_US",        // 英语
        "hi_HI",        // 印度
        "id_ID",        // 印尼
        "th_TH",        // 泰国
        "ms_MS",        // 马来西亚
        "vi_VI",        // 越南
        "ja_JP",        // 日本
        "ko_KO",        // 韩国
    ]

    PackageFlag = PackageConfig.PackageFlag     // 包标识
    UpdatePackageName = PackageConfig.updatePackageName // 检测热更新的包名
    PackageName = PackageConfig.PackageName     // 厅主名
    CloseYxd = PackageConfig.closeYxd           // 是否关闭游戏盾
    InstallSDK = PackageConfig.InstallSDK       // 0: openInstall 1: shareInstall 2: shareTrace

    // 游戏盾相关
    GameShieldAccessKey = PackageConfig.GameShieldAccessKey
    GameShieldGroupName = PackageConfig.GameShieldGroupName
    GameShieldDomain = PackageConfig.GameShieldDomain
    GameShieldPort = PackageConfig.GameShieldPort

    ServerAddresses = []            // 服务器地址

    constructor () {
        // 非正式服可以设置切换环境
        if (this.Environment !== 2) {
            this.Environment = parseInt(cc.sys.localStorage.getItem("ServerEnvironment") || "5")
        }
        if (this.Environment === 0){//测试1-多币种，
            this.ServerAddresses = [
                "http://test1.subo365.cc/",
            ]
        }
        else if (this.Environment === 1){//测试2-非国际化
            this.ServerAddresses = [
                "http://test2.subo365.cc/",
            ]
        }else if (this.Environment === 2) {//正式
            this.ServerAddresses = PackageConfig.ServerAddresses
        }else if (this.Environment === 3) {//测试3-新需求
            this.ServerAddresses = [
                'http://test3.subo365.cc/',
            ]
        }else if   (this.Environment === 4){//灰度1-非国际化
            // 测试环境
            this.ServerAddresses = [
                'http://huidu.subo365.bet',
            ]
        }else if   (this.Environment === 5){//灰度1-多币种
            // 测试环境
            this.ServerAddresses = [
                'http://gjhhuidu.subo365.cc',
            ]
        }
    }
}

export default new Constant()